import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { PersonCheckIcon } from 'foundations-assets/icons/components/PersonCheckIcon';
import { ViewIcon } from 'foundations-assets/icons/components/ViewIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Code } from 'foundations-components/transitional/components/Code';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TOOLS_INITIAL_COUNT = 3;
function ToolCard({
  tool
}) {
  var _tool$mcpToolAccessTy, _tool$mcpToolMetadata;
  // UDS guarantees these arrays are non-empty; fallbacks are defensive only
  const accessType = (_tool$mcpToolAccessTy = tool.mcpToolAccessType[0]) !== null && _tool$mcpToolAccessTy !== void 0 ? _tool$mcpToolAccessTy : 'READ_ONLY';
  const visibility = (_tool$mcpToolMetadata = tool.mcpToolMetadataVisibility[0]) !== null && _tool$mcpToolMetadata !== void 0 ? _tool$mcpToolMetadata : 'PUBLIC';
  const AccessIcon = accessType === 'READ_ONLY' ? ViewIcon : EditIcon;
  return /*#__PURE__*/_jsxs(CardWrapper, {
    marginBlockEnd: "300",
    compact: true,
    expandable: true,
    defaultExpanded: false,
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      paddingInlineEnd: "300",
      children: [/*#__PURE__*/_jsx(CardHeader, {
        title: /*#__PURE__*/_jsx(Text, {
          typography: "code-100",
          children: tool.mcpToolName
        }),
        titleSize: "extra-small"
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "end",
        gap: "100",
        children: [/*#__PURE__*/_jsx(AccessIcon, {
          size: "100",
          color: "text-primary-disabled"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-100",
          color: "text-primary-disabled",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `detailsPage.functionalityCard.tabs.mcpServer.tools.access.${accessType}`
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(CardSection, {
      paddingBlockStart: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "300",
        children: [/*#__PURE__*/_jsx(Text, {
          children: tool.mcpToolDescription
        }), /*#__PURE__*/_jsxs(Flex, {
          gap: "200",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "detail-100",
            color: "text-primary-disabled",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.functionalityCard.tabs.mcpServer.tools.metadataVisibility"
            })
          }), /*#__PURE__*/_jsxs(Code, {
            children: [unescapedText(`detailsPage.functionalityCard.tabs.mcpServer.tools.visibility.label.${visibility}`), /*#__PURE__*/_jsx(HelpIcon, {
              paddingInlineStart: "100",
              title: unescapedText(`detailsPage.functionalityCard.tabs.mcpServer.tools.visibility.${visibility}`),
              size: "100"
            })]
          })]
        })]
      })
    })]
  });
}
export function McpServerTab({
  mcpServer
}) {
  const {
    mcpUseCases,
    mcpTools,
    mcpFaqs
  } = mcpServer;
  const [showAllTools, setShowAllTools] = useState(false);
  const visibleTools = showAllTools ? mcpTools : mcpTools.slice(0, TOOLS_INITIAL_COUNT);
  const hasToggleTools = mcpTools.length > TOOLS_INITIAL_COUNT;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "600",
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "detailsPage.functionalityCard.tabs.mcpServer.description"
      })
    }), mcpUseCases.length > 0 && /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.functionalityCard.tabs.mcpServer.useCases.title"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "400",
        children: mcpUseCases.map((useCase, index) => /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "300",
          children: [/*#__PURE__*/_jsx(Flex, {
            flexShrink: 0,
            children: /*#__PURE__*/_jsx(PersonCheckIcon, {
              size: "600",
              color: "fill-accent-green-default"
            })
          }), /*#__PURE__*/_jsx(Text, {
            children: useCase
          })]
        }, `${useCase}-${index}`))
      })]
    }), mcpTools.length > 0 && /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        paddingBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.functionalityCard.tabs.mcpServer.tools.title"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        children: visibleTools.map((tool, index) => /*#__PURE__*/_jsx(ToolCard, {
          tool: tool
        }, `${tool.mcpToolName}-${index}`))
      }), hasToggleTools && /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: () => setShowAllTools(!showAllTools),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `detailsPage.functionalityCard.tabs.mcpServer.tools.${showAllTools ? 'seeLess' : 'seeMore'}`
        })
      })]
    }), mcpFaqs && mcpFaqs.length > 0 && /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "500",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        paddingBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.functionalityCard.tabs.mcpServer.faqs.title"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "300",
        children: mcpFaqs.map((faq, index) => /*#__PURE__*/_jsx(AccordionItem, {
          size: "xs",
          title: /*#__PURE__*/_jsx(Text, {
            typography: "heading-100",
            children: faq.mcpFaqQuestion
          }),
          paddingBlockEnd: "400",
          children: /*#__PURE__*/_jsx(Text, {
            paddingBlockStart: "100",
            children: faq.mcpFaqAnswer
          })
        }, `${faq.mcpFaqQuestion}-${index}`))
      })]
    })]
  });
}